import { useEffect } from 'react';

import { i18n } from 'src/i18n';
import { useAppSelector } from 'src/state/thunk-api';

import { selectHasOrderBeenConfirmed, selectHasOrderProcessStartedOrCompleted, selectOrderFailed } from './selectors';

const beforeUnloadListener = (ev: BeforeUnloadEvent) => {
  ev.preventDefault();
  ev.returnValue = i18n.navigationLockMessage;
  return ev.returnValue;
};

export const useNavPromptWhileOrdering = (): void => {
  const hasStarted = useAppSelector(selectHasOrderProcessStartedOrCompleted);
  const hasFinished = useAppSelector(selectHasOrderBeenConfirmed);
  const hasOrderFailed = useAppSelector(selectOrderFailed);

  useEffect(() => {
    if (hasStarted && !hasFinished) {
      window.addEventListener('beforeunload', beforeUnloadListener);
    } else if (hasFinished || hasOrderFailed) {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    }
  }, [hasFinished, hasStarted, hasOrderFailed]);
};
